import { fn_deliveryPartnerFail } from "../function/FnBodyLayer";
import { Fn_activeAxios } from "../function/FnConfig";
import { fn_log_error } from "function/FnPosBridge"
import { fn_devliery_request } from "function/FnBodyDelivery"
import { reload_order_list_all } from "http/OrderConn"
import { pay_free_yntype } from "http/SettingConn"

// 원토스,TPAY 배달대행업체 조회
export async function search_dlv_store_info(rootStore) {

    let data = JSON.stringify(
        {
            shopCd: rootStore.searchStore.getShopCd,
        }
    )

    const api = Fn_activeAxios(rootStore);

    let response = await api.post('/gate/okgo/select_delivery_partner', data, {
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + rootStore.searchStore.getToken }
    })
        .then((res) => {
            if (res && res.status === 200) {
                if (res.data.resultCode === "000") {
                    const data = res.data.data;
                    if (data && data.length > 0) {
                        rootStore.deliveryStore.setExpDelivery(data);
                    }
                } else {
                    fn_deliveryPartnerFail(rootStore);
                }
            } else {
                fn_deliveryPartnerFail(rootStore);
            }
        }).catch(err => {
            fn_deliveryPartnerFail(rootStore);
        });
    return response;
}

// ASP 배달사원 전체 조회
export function search_dlv_Maninfo(rootStore) {

    let data = JSON.stringify(
        {
            shopCd: rootStore.searchStore.getShopCd,
            actionFlag: 'R',
        }
    )

    const api = Fn_activeAxios(rootStore);
    api.post('/gate/okgo/deliveryManInfo', data, {
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + rootStore.searchStore.getToken }
    })
        .then((res) => {
            if (res && res.status === 200) {
                if (res.data.resultCode === "000") {
                    const data = res.data.data;
                    if (data && data.length > 0) {
                        rootStore.deliveryStore.setDeliveryAsp(data);
                    }
                }
            }
        }).catch(err => {
        });
}

//최신 주소 호출[멀티포스 관련]
export function recent_addr(rootStore) {

    let data = JSON.stringify(
        {
            mobileOrderNo: rootStore.viewStore.getOrderDetail.mobileOrderNo,
            saleDate: rootStore.viewStore.getOrderDetail.saleDate,
            shopCd: rootStore.searchStore.getShopCd,
        }
    )

    const api = Fn_activeAxios(rootStore);
    api.post('/gate/okgo/recent-address', data, {
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + rootStore.searchStore.getToken }
    })
        .then((res) => {
            if (res && res.status === 200) {
                if (res.data.resultCode === "000") {
                    const data = res.data.data;
                    if (data.addr2 == rootStore.viewStore.getOrderDetail.addr2 || data.dlvAddr == rootStore.viewStore.getOrderDetail.dlvAddr || data.dlvAddrFull == rootStore.viewStore.getOrderDetail.dlvAddrFull) {
                        fn_devliery_request(rootStore)
                    } else {
                        rootStore.layerStore.setLayerAlertType("recent_addr_fail");
                        rootStore.layerStore.setLayerAlertView(true);
                    }

                }
            }
        }).catch(err => {
        });
}


//배민 주문 배달 상태 변경
export function dlv_status_baemin(rootStore, state, orderNo) {

    //배민콜백확인
    fn_log_error("", "BAEMIN_STATUS", state + "/" + orderNo);
    
    let data = JSON.stringify(
        {
            shopCd: rootStore.searchStore.getShopCd,
            changeState: state,
            orderNo: orderNo,
        }
    )
    const api = Fn_activeAxios(rootStore);
    api.post('/gate/baemin/status', data, {
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + rootStore.searchStore.getToken }
    })
        .then((res) => {
            if (res && res.status === 200) {
                reload_order_list_all(rootStore);
            }
        }).catch(err => {
        });
}

//메인 배달대행사 설정 (예상 배달비 조회)
export function main_dlv(rootStore, tp) {
    let data = JSON.stringify(
        {
            shopCd: rootStore.searchStore.getShopCd,
            tp: tp
        }
    )
    const api = Fn_activeAxios(rootStore);
    api.post('/gate/okgo/subscriptions/main', data, {
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + rootStore.searchStore.getToken }
    })
        .then((res) => {
            if (res && res.status === 200) {
                rootStore.settingStore.setMainDlv(res.data.data.codeName)
                rootStore.settingStore.setDlvSelectListView(false);
                pay_free_yntype(rootStore)
            }
        }).catch(err => {
        });
}